import React from 'react'
import './Eng_content.css'

const Eng_content = () => {
    return (
        <>
            <section className='Eng_contentsec'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-7 mx-auto'>
                            <h2 className='engcontenttitle'>Designed for the Beginning of Forever</h2>
                            <p className='engcontentpara'>An engagement ring is not just jewelry. It is a commitment, a milestone, and a legacy piece that carries emotion across generations.</p>
                            <p className='engcontentpara'>
                                At <strong>ARC DIAMOND JEWELRY,</strong> we craft engagement rings that balance modern elegance with timeless craftsmanship — using ethically sourced natural and lab-grown diamonds, precision setting, and clean design language.
                            </p>
                        </div>
                    </div>

                    <div className='row justify-content-center  mt-5'>

                        <div className='col-lg-4 col-10 mb-3 text-start'>
                            <h2 className='engcontenttitle'>OUR PHILOSOPHY</h2>
                            <p className='engcontentpara'>We believe engagement rings should be:</p>
                            <ul>
                                <li className='engcontentpara'>Elegant, not excessive</li>
                                <li className='engcontentpara'>Premium, not overpriced</li>
                                <li className='engcontentpara'>Crafted for daily wear</li>
                                <li className='engcontentpara'>Designed to last generations</li>
                            </ul>
                            <p className='engcontentpara'>Each ring is manufactured with strict quality control, precise finishing, and diamond grading transparency.</p>
                        </div>

                        <div className='col-lg-4 col-10 mb-3 text-start'>
                            <h2 className='engcontenttitle'>WHY CHOOSE ARC DIAMOND JEWELRY</h2>
                            <ul>
                                <li className='engcontentpara'>Transparent pricing structure</li>
                                <li className='engcontentpara'>Export-quality finishing</li>
                                <li className='engcontentpara'>International diamond standards</li>
                                <li className='engcontentpara'>Secure global shipping</li>
                                <li className='engcontentpara'>Direct manufacturer pricing</li>
                            </ul>
                        </div>


                        <div className='col-lg-4 col-10 mb-3 text-start'>
                            <h2 className='engcontenttitle'>PRIVATE CONSULTATION</h2>
                            <p className='engcontentpara'>Looking for a specific size, shape, or budget range?</p>
                            <p className='engcontentpara'>Book a private consultation with our design team to create an engagement ring aligned with your vision and budget.</p>
                            <p className='engcontentpara'>If you want, I can now:</p>
                            <ul>
                                <li className='engcontentpara'>Refine this for USA audience tone</li>
                                <li className='engcontentpara'>Refine for Dubai market luxury positioning</li>
                                <li className='engcontentpara'>Create a lab-grown specific engagement page</li>
                                <li className='engcontentpara'>Or make it more aggressive for conversions</li>
                            </ul>
                        </div>



                    </div>


                </div>
            </section>
        </>
    )
}

export default Eng_content